import { Button } from "src/elements";
import { useApi } from "src/api";
import { useLoaders } from "src/components/InlineLoader";
import { RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs } from "@CommonApi/merchflows/_merchflowId_/s0/_s0SolutionId_/logs";
import { downloadFile } from "src/utils";

interface Props {
  merchflowId: number;
  s0SolutionId: number;
}

export const S0LogsButton = ({ merchflowId, s0SolutionId }: Props) => {
  const { getMerchflowS0LogsApi } = useApi();
  const { hasLoader } = useLoaders();

  const downloadLogs = async (logsType: "algo_request" | "algo_response") => {
    const response = await getMerchflowS0LogsApi(merchflowId, s0SolutionId);
    if (response?.[logsType]) {
      downloadFile({
        name: `s0_${logsType}_${s0SolutionId}`,
        extension: "json",
        data: JSON.stringify(response[logsType], null, 2),
      });
    }
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      dropdown={[
        { label: "S0 Request", onClick: () => downloadLogs("algo_request") },
        { label: "S0 Response", onClick: () => downloadLogs("algo_response") },
      ]}
      isLoading={hasLoader(RouteGetMerchflows_merchflowId_S0_s0SolutionId_logs)}
    >
      Logs
    </Button>
  );
};
